"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = require("./dayjs");
var dates_1 = require("../constants/dates");
exports.isBetweenTwoDates = function (startDate, endDate, timezone) {
    var day = timezone ? dayjs_1.dayjs().tz(timezone) : dayjs_1.dayjs();
    var currentTime = day.format(dates_1.MomentFormats.DateFormat);
    var momentStartDate = dayjs_1.dayjs(startDate);
    var momentEndDate = dayjs_1.dayjs(endDate);
    return !!dayjs_1.dayjs(currentTime).isBetween(momentStartDate, momentEndDate, undefined, '[]');
};
exports.isBetweenTwoTimes = function (startTime, endTime, timezone) {
    var day = timezone ? dayjs_1.dayjs().tz(timezone) : dayjs_1.dayjs();
    var currentDate = day.format(dates_1.MomentFormats.DateFormat);
    var currentTime = day.format(dates_1.MomentFormats.DateTimeFormat);
    var momentStartTime = dayjs_1.dayjs(currentDate + " " + startTime);
    var momentEndTime = dayjs_1.dayjs(currentDate + " " + endTime);
    return !!dayjs_1.dayjs(currentTime).isBetween(momentStartTime, momentEndTime, undefined, '[]');
};
var getLegalAge = function (province) {
    switch (province) {
        case 'AB':
        case 'QC':
            return 18;
        case 'BC':
        case 'SK':
        case 'MB':
        case 'ON':
        case 'NS':
        case 'NB':
        case 'PE':
        case 'NL':
        case 'YT':
        case 'NT':
        case 'NU':
            return 19;
        default:
            return 19;
    }
};
exports.isLegalAge = function (birthday, province) {
    var today = dayjs_1.dayjs().format('YYYY-MM-DD');
    var age = dayjs_1.dayjs(today).diff(birthday, 'years');
    var isLegal = (age >= getLegalAge(province));
    return isLegal;
};
exports.getLegalDateOfBirth = function (province) {
    var age = getLegalAge(province);
    var legalDob = dayjs_1.dayjs().subtract(age, 'years').format('YYYY-MMM-DD');
    return legalDob;
};
//# sourceMappingURL=date.js.map